import { useContext } from "react";
import {
  Flex,
  Avatar,
  Text,
  Badge,
  AvatarGroup,
  Box,
  useColorMode,
  Center,
} from "@chakra-ui/react";

// Components
import { CustomBoostTag } from "components/Defi/Custom";

// Config
import { currentNetworkInfo } from "config/network";

// Constants
import { CLICK_DEFI_PARTNER_CARD } from "constants/analytics";

// Contexts
import { StakeContext } from "providers/StakeProvider";

type Props = {
  icon: any;
  tokenIcon: any;
  token?: string;
  id: string;
  partnerName: string;
  link: string;
  apy: string;
  tvl: string;
  showTVL: boolean;
  hasAPYBoost?: boolean;
  orgAPY?: string;
  highlight: string;
};

const DefiCard = ({
  icon,
  token,
  tokenIcon,
  id,
  partnerName,
  link,
  apy,
  tvl,
  showTVL,
  hasAPYBoost = false,
  orgAPY,
  highlight,
  ...rest
}: Props) => {
  const { track } = useContext(StakeContext);
  const { colorMode } = useColorMode();

  return (
    <Center
      as="a"
      flexDir="column"
      border="1px solid #C9C9C9"
      borderRadius="0.5rem"
      p="1.2rem"
      textAlign="center"
      maxW="190px"
      position="relative"
      cursor="pointer"
      href={link}
      target="_blank"
      rel="noreferrer"
      onClick={() => track(CLICK_DEFI_PARTNER_CARD, { defi_name: id })}
      _dark={{
        bg: "#333333",
        borderColor: "#333333",
      }}
      {...rest}
    >
      {(hasAPYBoost || highlight) && (
        <Box position="absolute" top="-1px" left="-1px">
          <CustomBoostTag
            mt="0px"
            borderTopRightRadius="0px"
            borderBottomLeftRadius="0px"
            tag={hasAPYBoost ? "STADER BOOST" : highlight}
          />
        </Box>
      )}

      <Center mb="1rem" mt="1rem">
        <Avatar
          h="40px"
          w="40px"
          name="platform"
          src={icon[colorMode].src}
          bg="none"
        />
      </Center>
      <Text fontFamily="semi-bold" fontSize="16px" mb="0.5rem">
        {partnerName}
      </Text>
      <Badge
        fontSize="10px"
        lineHeight="12px"
        bg="brand.success"
        color="#38A169"
        borderRadius="12px"
        p="4px"
        mb="1rem"
      >
        <Flex align="center" gap="4px" p="4px">
          <Text as="span" fontSize="14px">
            {showTVL ? "TVL" : "APY"}
          </Text>
          <Text as="span" fontSize="14px">
            {showTVL ? tvl : `${apy || "- "}%`}
            {hasAPYBoost && (
              <Text
                as="span"
                fontFamily="light"
                fontSize="12px"
                ml=".25rem"
                textDecoration="line-through"
              >
                {`${orgAPY} %`}
              </Text>
            )}
          </Text>
        </Flex>
      </Badge>
      <Flex align="center" h="20px" gap="0.5rem" justify="center">
        <Box h="20px">
          <AvatarGroup
            spacing="-2"
            justifyContent="center"
            mb="0.5rem"
            size="xs"
          >
            <Avatar
              bg="brand.background"
              name="MaticX"
              src={currentNetworkInfo.tokenXIcon[colorMode].src}
              zIndex="1"
              borderWidth="0"
            />
            {tokenIcon && (
              <Avatar
                bg="brand.background"
                name="token"
                src={tokenIcon[colorMode].src}
                borderWidth="0"
              />
            )}
          </AvatarGroup>
        </Box>
        <Text fontSize="12px" lineHeight="20px">
          MaticX {token && `/ ${token}`}
        </Text>
      </Flex>
    </Center>
  );
};

export default DefiCard;
